import { addShipmentApi } from "./addShipmentApi";

export const addShipmentSetData = async (
  lang,
  setMessageResponse,
  cookies,
  payload,
  setSuccessMessage,
  setBtnLoader,
  userId
) => {

  const response = await addShipmentApi(payload, lang, cookies , userId);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "add",
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
